{
	"serial": true,
	"data": {
		"actionLevel": true,
		"analysis": {
			"auPlating": true,
			"baseName": true,
			"coatingConfigName": true,
			"collimated": true,
			"compoundSuppress100Warning": true,
			"compoundTemplateName": true,
			"dailyId": true,
			"elevation": true,
			"final": true,
			"gradeCompareEnable": true,
			"latitude": true,
			"longitude": true,
			"methodDispName": true,
			"methodFamilyName": true,
			"methodId": true,
			"pseudoElementConfigName":  true,
			"repeatTestIndex": true,
			"repeatTestTotal": true,
			"rohsActionLevel": true,
			"rohsActionLevelName": true,
			"rohsClassification": true,
			"statusId": true,
			"testDateTime": true,
			"testErrorInfo": true,
			"testId": true,
			"testType": true,
			"tiTemplateName": true,
			"tidName": true,
			"userFactorName": true,
			"userFactorNormalizeFactor": true,
			"userId": true
		},
		"chemistry": [
			{
				"concentration": true,
				"elementName": true,
				"error": true
			}
		],
		"compound": true,
		"gradeMatch": [
			{
				"compGrade": true,
				"gradeName": true,
				"gradeSpec": [
					{
						"elementName": true,
						"matchResult": true,
						"maxVal": true,
						"minVal": true,
						"testId": true
					}
				],
				"matchMessage": true,
				"matchNSigma": true,
				"matchNumber": true,
				"nominalFactor": true,
				"passFailCutOff": true,
				"passFailNSigma": true,
				"passFailShowMatchNumber": true,
				"testId": true
			}
		],
		"hasCalCheckResult": true,
		"images": [
			{
				"collimatorSpotX": true,
				"collimatorSpotY": true,
				"cropAreaHeight": true,
				"cropAreaLeft": true,
				"cropAreaTop": true,
				"cropAreaWidth": true,
				"fileName": true,
				"imageType": true
			}
		],
		"pseudoElement": [
			{
				"concentration": true,
				"elementName": true,
				"error": true,
				"formula": true,
				"notApplicable": true
			}
		],
		"regressionInfo": {
			"historicalDailyId": true,
			"historicalDateTime": true,
			"historicalTestId": true,
			"historicalTidName": true
		},
		"spectra": [
			{
				"ambientPressure": true,
				"clipBottom": true,
				"clipTop": true,
				"colMultiplier": true,
				"detectorTemperature": true,
				"energyOffset": true,
				"energySlope": true,
				"exposureNumber": true,
				"fastCounts": true,
				"filter": {
					"diameterInMicrons": true,
					"hasCollimator": true,
					"materialAtomicNumber": true,
					"thicknessInMicrons": true
				},
				"filterPosition": true,
				"firstRate": true,
				"inputCountRate": true,
				"isFinal": true,
				"lastRate": true,
				"liveTime": true,
				"liveTimeFromHardware": true,
				"ltMultiplier": true,
				"outputCountRate": true,
				"pileups": true,
				"probeSerialNumber": true,
				"probeTemperature": true,
				"realTime": true,
				"resetCount": true,
				"resetTime": true,
				"slowCounts": true,
				"stepIndex": true,
				"stepTotal": true,
				"topResets": true,
				"totalCounts": true,
				"totalExposureNumber": true,
				"totalRate": true,
				"tubeCurrentMonitor": true,
				"tubeCurrentSet": true,
				"tubeVoltageMonitor": true,
				"tubeVoltageSet": true,
				"vacuumPressure": true,
				"widthRejects": true
			}
		],
		"stopCurrentExposure": true,
		"testId": true,
		"testInfo": {
			"info": true
		},
		"userFactor": true
	}
}